// src/components/ComingSoon.jsx (actualizado con funcionalidad de login)
import React, { useState, useEffect } from 'react';
import Footer from './Footer';
import logoImg from '../assets/logo.png';
import './ComingSoon.css';

const ComingSoon = ({ onLoginClick }) => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Fecha objetivo - 30 días desde hoy
  const targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + 30);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      setEmail('');
      console.log('Email registrado:', email);
    }
  };

  const CountdownItem = ({ value, label }) => (
    <div className="text-center bg-white/10 backdrop-blur-lg rounded-2xl p-6 border-2 border-white/20 hover:border-white/40 transition-all duration-500 hover:bg-white/15 hover:shadow-2xl">
      <div className="text-4xl md:text-5xl font-black text-white mb-2">
        {value.toString().padStart(2, '0')}
      </div>
      <div className="text-gray-200 text-sm font-medium uppercase tracking-wider">
        {label}
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 flex flex-col">
      {/* Hero Section */}
      <section className="flex-1 flex items-center justify-center px-4 py-16 relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0 bg-[url('https://cdn.shopify.com/s/files/1/0399/8685/6102/files/DSC_08961.jpg?v=1697039409')] bg-center bg-cover bg-no-repeat opacity-20"></div>
        <div className="absolute inset-0 bg-gradient-to-br from-blue-800/50 to-purple-900/50"></div>

        {/* Animated Background Elements */}
        <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-packsys-orange/20 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-1/3 right-1/4 w-24 h-24 bg-blue-400/20 rounded-full blur-xl animate-pulse animation-delay-1000"></div>
        <div className="absolute top-1/3 right-1/3 w-20 h-20 bg-purple-400/20 rounded-full blur-xl animate-pulse animation-delay-2000"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10">
          {/* Logo/Brand */}
          <div className="flex items-center justify-center mb-8 animate-fade-in-down">
            <div className="p-3 bg-white rounded-2xl">
              <img className="h-12" src={logoImg} alt="Logo Packsys" />
            </div>
          </div>

          {/* Main Content */}
          <div className="animate-fade-in-up">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-packsys-orange to-yellow-400">
                Tracking
              </span>{' '}
              Packsys
            </h1>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-6 leading-tight">
              está en{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-packsys-orange to-yellow-400">
                camino
              </span>
            </h1>
            <p className="text-xl text-gray-200 mb-12 max-w-2xl mx-auto leading-relaxed">
              Estamos trabajando para traerte una mejor experiencia en tus
              pedidos.
            </p>
            {/* Email Subscription */}
            {/*  
            {!isSubscribed ? (
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border-2 border-white/20 max-w-md mx-auto mb-8">
                <h3 className="text-white text-xl font-bold mb-4">
                  Notifícame el lanzamiento
                </h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="relative">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="tu@email.com"
                      className="w-full bg-white/95 text-slate-800 border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-packsys-orange focus:border-transparent"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-packsys-orange to-orange-500 text-white py-3 px-4 rounded-xl font-semibold hover:from-orange-500 hover:to-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl"
                  >
                    Notificarme
                  </button>
                </form>
              </div>
            ) : (
              <div className="bg-green-500/20 backdrop-blur-lg rounded-2xl p-6 border-2 border-green-400/30 max-w-md mx-auto mb-8 animate-scale-in">
                <div className="flex items-center justify-center space-x-3">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                    <svg
                      className="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={3}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <span className="text-white font-semibold">
                    ¡Gracias! Te notificaremos pronto.
                  </span>
                </div>
              </div>
            )}
              */}

            <div className="space-y-6">
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border-2 border-white/20 shadow-2xl">
                <div className="text-center mb-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                  </div>

                  <h3 className="text-white text-xl font-bold mb-2">
                    Acceso para Testers
                  </h3>
                  <p className="text-gray-200 text-sm">
                    Credenciales exclusivas para el equipo de testing
                  </p>
                </div>

                <button
                  onClick={onLoginClick}
                  className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-4 px-6 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 transform group relative overflow-hidden"
                >
                  <span className="relative z-10 flex items-center justify-center space-x-3">
                    <svg
                      className="w-5 h-5 group-hover:scale-110 transition-transform duration-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                    <span className="text-lg">Ingresar al Sistema</span>
                  </span>

                  {/* Efecto de brillo al hover */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ComingSoon;
